import React from 'react';
import { motion } from 'framer-motion';
import { Input } from './ui/input';
import { Search } from 'lucide-react';

const SEARCH_INITIAL = { opacity: 0, y: 20 };
const SEARCH_ANIMATE = { opacity: 1, y: 0 };
const SEARCH_TRANSITION = { duration: 0.5, delay: 0.6 };

export const HeroSearchBar = ({ query, setQuery, placeholder }) => (
  <motion.div
    className="relative"
    initial={SEARCH_INITIAL}
    animate={SEARCH_ANIMATE}
    transition={SEARCH_TRANSITION}
  >
    <Search className="absolute left-5 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
    <Input
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      placeholder={placeholder}
      className="pl-14 pr-6 py-6 text-lg rounded-2xl bg-muted border-none focus-visible:ring-2 focus-visible:ring-primary"
      data-testid="search-input"
    />
  </motion.div>
);
